import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { EMPTY, merge } from 'rxjs';
import { catchError, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { getBatchTabContentToPersist } from 'state/selectors';
import type { EpicWithThunk } from 'state/state.common';
import {
  workspaceTabContentCleared,
  workspaceTabContentPersisted,
} from 'state/workspaces/tabContent/tabContent.actions';

export function persistBatchWorkspaceTabContentOnTabResetCompletedEpic(): EpicWithThunk {
  return (actions$, state$, { httpClient }) =>
    actions$.pipe(
      ofType('WORKSPACE_RESET_TAB_COMPLETED'),
      filter(action => action.workspace === 'newBatch'),
      withLatestFrom(state$),
      mergeMap(([{ id, newId }, state]) => {
        const tabContent = getBatchTabContentToPersist(state, newId);

        if (tabContent === undefined) {
          return EMPTY;
        }
        const api$ = tabsApiConnector(httpClient, 'newBatch');

        return merge(
          api$.clearTabContent(id).pipe(
            map(_ => workspaceTabContentCleared(id, 'newBatch')),
            catchError((_: Error) => {
              return EMPTY;
            }),
          ),

          api$.updateTabContent(newId, tabContent).pipe(
            map(_ => workspaceTabContentPersisted(newId, tabContent, 'newBatch')),
            catchError((_: Error) => {
              return EMPTY;
            }),
          ),
        );
      }),
    );
}
